"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.regexp.match");

var _ErrorModal = require("../../Components/Modal/ErrorModal");

var _react = _interopRequireDefault(require("react"));

var _errors = require("../../Utils/errors");

var _logger = _interopRequireDefault(require("../../Utils/logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var logger = (0, _logger.default)();

var ErrorBoundary =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ErrorBoundary)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      asyncChunkLoadError: false,
      genericError: false,
      errorStack: ""
    });

    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      logger.error(new _errors.ErrorWithMetadata(error.message, errorInfo));

      if (this.props.onCatch) {
        this.props.onCatch();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          asyncChunkLoadError = _this$state.asyncChunkLoadError,
          genericError = _this$state.genericError,
          errorStack = _this$state.errorStack;

      switch (true) {
        case asyncChunkLoadError:
          {
            return _react.default.createElement(ErrorModalWithReload, {
              message: "Please check your network connection and try again.",
              show: asyncChunkLoadError
            });
          }

        case genericError:
          {
            return _react.default.createElement(ErrorModalWithReload, {
              show: genericError,
              errorStack: errorStack
            });
          }
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      var errorStack = error.stack;
      /**
       * Check to see if there's been a network error while asynchronously loading
       * a dynamic webpack split chunk bundle. Can happen if a user is navigating
       * between routes and their network connection goes out.
       *
       * @see https://reactjs.org/docs/code-splitting.html
       */

      if (error.message.match(/Loading chunk .* failed/)) {
        return {
          asyncChunkLoadError: true,
          errorStack: errorStack
        };
      }

      return {
        genericError: true,
        errorStack: errorStack
      };
    }
  }]);

  return ErrorBoundary;
}(_react.default.Component);
/**
 * An error popup with the option to reload the page
 */


exports.ErrorBoundary = ErrorBoundary;

var ErrorModalWithReload = function ErrorModalWithReload(_ref) {
  var message = _ref.message,
      show = _ref.show,
      errorStack = _ref.errorStack;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ErrorModal.ErrorModal, {
    show: show,
    detailText: message,
    errorStack: errorStack,
    closeText: "Reload",
    ctaAction: function ctaAction() {
      location.reload();
    }
  }));
};
//# sourceMappingURL=ErrorBoundary.js.map